<template>
  <el-row id="carInfoView">
    <el-dialog :title="dialogTitle"
               width="55%"
               top="7vh"
               v-loading="true"
               :visible.sync="dialogFormVisible"
               v-dialogDrag>
      <el-form ref="form"
               :model="form"
               label-width="110px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="最后操作时间">
              <el-input v-model="form.fOpLastTime"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="最后操作用户">
              <el-input v-model="form.fOpUserName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车牌来源">
              <el-input v-model="form.fConfidence"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="车牌号码">
              <el-input v-model="form.fPlateCode"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车牌颜色">
              <el-input v-model="form.fPlateColor"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车辆类型">
              <el-input v-model="form.fCarTypeName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="月卡用户">
              <el-input v-model="form.CustName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="月卡类型">
              <el-input v-model="form.fCardTypeName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="月卡分组">
              <el-input v-model="form.fCardGroupName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="进场时间">
              <el-input v-model="form.fInTime"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="进场通道">
              <el-input v-model="form.fInParkChnlName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="进场方式">
              <el-input v-model="form.fInStatus"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="进场识别车牌">
              <el-input v-model="form.fInPlate"
                        :class="{ isRed: form.fInPlate!=form.fPlateCode }"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="进场备注">
              <el-input v-model="form.fInRemark"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="进场操作员">
              <el-input v-model="form.fInUserName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="出场时间">
              <el-input v-model="form.fOutTime"
                        :class="{ isRedColor: form.isRedOutTime==true }"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出场通道">
              <el-input v-model="form.fOutParkChnlName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出场方式">
              <el-input v-model="form.fOutStatus"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="出场识别车牌">
              <el-input v-model="form.fOutPlate"
                        :class="{ isRed: form.fOutPlate!=form.fPlateCode }"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出场备注">
              <el-input v-model="form.fOutRemark"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出场操作员">
              <el-input v-model="form.fOutUserName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="停车时长">
              <el-input v-model="form.fTotalSecs"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="免费时长">
              <el-input v-model="form.fFreeSecs"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="计费时长">
              <el-input v-model="form.fPaySecs"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :span="8">
            <el-form-item label="计费费率">
              <el-input v-model="form.fRateGroupName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="8">
            <el-form-item label="普通日费率">
              <el-input v-model="form.fCommRateName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="节假日费率">
              <el-input v-model="form.fHolidayRateName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="计费金额">
              <el-input v-model="form.fCalcAmt"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="支付金额">
              <el-input v-model="form.fPayAmt"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="交班时间">
              <el-input v-model="form.fExgDate"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="交班用户">
              <el-input v-model="form.fExgUserName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="客户编号">
              <el-input v-model="form.fCustNo"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="客户ID">
              <el-input v-model="form.fCustID"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="订单ID">
              <el-input v-model="form.fBusID"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-tabs v-model="activeName"
               type="card">
        <el-tab-pane label="进出图片"
                     name="first">
          <el-row>
            <el-col :span="12"
                    class="tab_img">
              <div class="block">
                <span class="demonstration"
                      v-if="(form.fInExpiredTip||'').trim().length<=0">进场图片</span>
                <span class="demonstration"
                      v-else
                      style="color:red">{{form.fInExpiredTip}}</span>
                <img src="../assets/images/zoom.png"
                     alt="详情"
                     title="详情"
                     class="img_zoom"
                     :style="{display:in_display}"
                     @click="show_dev_in" />
                <el-image :src="form.fInPic"
                          @load="in_load">
                  <div slot="error"
                       class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
            </el-col>
            <el-col :span="12"
                    class="tab_img">
              <div class="block">
                <span class="demonstration"
                      v-if="(form.fOutExpiredTip||'').trim().length<=0">出场图片</span>
                <span class="demonstration"
                      v-else
                      style="color:red">{{form.fOutExpiredTip}}</span>
                <img src="../assets/images/zoom.png"
                     alt="详情"
                     title="详情"
                     class="img_zoom"
                     :style="{display:out_display}"
                     @click="show_dev_out" />
                <el-image :src="form.fOutPic"
                          @load="out_load">
                  <div slot="error"
                       class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane :label="payTitle"
                     name="second">
          <el-row>
            <el-col :span="24">
              <el-table :data="payData"
                        border
                        stripe
                        style="width: 100%">
                <el-table-column prop="fRowNumber"
                                 width="50"
                                 label="序号">
                </el-table-column>
                <el-table-column prop="fPayTime"
                                 width="160"
                                 label="时间">
                </el-table-column>
                <el-table-column prop="fPayment"
                                 width="200"
                                 label="支付方式">
                </el-table-column>
                <el-table-column prop="fPayCount"
                                 align="right"
                                 width="120"
                                 label="支付数量">
                </el-table-column>
                <el-table-column prop="fPayAmount"
                                 align="right"
                                 width="120"
                                 label="支付金额">
                </el-table-column>
                <el-table-column prop="fRemark"
                                 label="备注">
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="dialog_dev_Title"
               width="55%"
               top="7vh"
               :visible.sync="dialogdevFormVisible"
               v-dialogDrag>
      <!-- <el-row>
          <el-col :span="24">
            <div class="car_img">
              <img :src="(is_out ? form.fOutPic : form.fInPic )" />
            </div>
          </el-col>
        </el-row> -->
      <el-row>
        <el-col :span="12">
          <div class="car_img">
            <el-row>
              <div class="fplate_info">
                <div style="float:left;width:200px;">
                  <el-image :src="(is_out ? form.fOutPlatePic : form.fInPlatePic )">
                    <div slot="error"
                         class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </div>
                <div style="float:left;margin-left:20px;">
                  <div><span class="fplate_span">{{form.fPlateCode}}</span></div>
                  <div><span class="fplate_span">{{form.fPlateColor}}</span></div>
                  <div><span class="fplate_span">{{form.fConfidence}}</span></div>
                </div>
              </div>
            </el-row>
            <img :src="(is_out ? form.fOutPic : form.fInPic )"
                 class="img" />
          </div>
        </el-col>
        <el-col :span="12">
          <el-form label-width="105px"
                   class="form_right">
            <!-- <fieldset>
              <legend>当前车辆</legend>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="当前车牌">
                    <el-input v-model="form.fPlateCode_Color"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="车辆来源">
                    <el-input v-model="form.fConfidence"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </fieldset> -->
            <fieldset v-if="!is_out">
              <legend>进场图片信息</legend>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="进场时间">
                    <el-input v-model="form.fInTime"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="操作用户">
                    <el-input v-model="form.fInUserName"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="进场场库">
                    <el-input v-model="form.fInParkName"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="进场通道">
                    <el-input v-model="form.fInChnlName"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="识别车牌">
                    <el-input v-model="form.fInPlate"
                              :class="{ isRed: form.fInPlate!=form.fPlateCode }"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="识别可信度">
                    <el-input v-model="form.fInConfidence"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="进场方式">
                    <el-input v-model="form.fInStatus"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="抓拍模式">
                    <el-input v-model="form.fInCapMode"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="进场备注"
                                class="fInRemark_item">
                    <el-input type="textarea"
                              :rows="2"
                              v-model="form.fInRemark"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </fieldset>
            <fieldset v-if="is_out">
              <legend>出场图片信息</legend>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="出场时间">
                    <el-input v-model="form.fOutTime"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="操作用户">
                    <el-input v-model="form.fOutUserName"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="出场场库">
                    <el-input v-model="form.fOutParkName"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="出场通道">
                    <el-input v-model="form.fOutChnlName"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="识别车牌">
                    <el-input v-model="form.fOutPlate"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="识别可信度">
                    <el-input v-model="form.fOutConfidence"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="出场方式">
                    <el-input v-model="form.fOutStatus"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="抓拍模式">
                    <el-input v-model="form.fOutCapMode"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="出场备注"
                                class="fInRemark_item">
                    <el-input type="textarea"
                              :rows="2"
                              v-model="form.fOutRemark"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </fieldset>
            <fieldset v-if="!is_out">
              <legend>进场设备信息</legend>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="摄像机IP">
                    <el-input v-model="form_dev.fInCamIP"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="摄像机类型">
                    <el-input v-model="form_dev.fInCamType"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="道闸控制设备IP">
                    <el-input v-model="form_dev.fInGateIP"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="道闸类型">
                    <el-input v-model="form_dev.fInGateType"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="车辆方向">
                    <el-input v-model="form_dev.fInVehDir"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="车身颜色">
                    <el-input v-model="form_dev.fInCarColor"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="进场速度">
                    <el-input v-model="form_dev.fInSpeed"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="报警类型">
                    <el-input v-model="form_dev.fInAlarm"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="车辆品牌">
                    <el-input v-model="form_dev.fInBrand"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="车辆类型">
                    <el-input v-model="form_dev.fInVehType"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </fieldset>
            <fieldset v-if="is_out">
              <legend>出场设备信息</legend>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="摄像机IP">
                    <el-input v-model="form_dev.fOutCamIP"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="摄像机类型">
                    <el-input v-model="form_dev.fOutCamType"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="道闸控制设备IP">
                    <el-input v-model="form_dev.fOutGateIP"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="道闸类型">
                    <el-input v-model="form_dev.fOutGateType"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="车辆方向">
                    <el-input v-model="form_dev.fOutVehDir"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="车身颜色">
                    <el-input v-model="form_dev.fOutCarColor"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="出场速度">
                    <el-input v-model="form_dev.fOutSpeed"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="报警类型">
                    <el-input v-model="form_dev.fOutAlarm"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="车辆品牌">
                    <el-input v-model="form_dev.fOutBrand"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="车辆类型">
                    <el-input v-model="form_dev.fOutVehType"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </fieldset>
          </el-form>
        </el-col>
      </el-row>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="dialogdevFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </el-row>
</template>
<script>
import { report as api } from '../api/report'
export default {
  name: 'carInfoView',
  data () {
    return {
      payData: [],
      is_out: false,
      in_display: 'none',
      out_display: 'none',
      dialogTitle: '',
      dialog_dev_Title: '',
      dialogFormVisible: false,
      dialogdevFormVisible: false,
      activeName: 'first',
      payTitle: '支付明细',
      form: {
        isRedOutTime: '',
        fCustName: '',
        fParkName: '',
        fOpLastTime: '',
        fOpUserName: '',
        fConfidence: '',
        fPlateCode: '',
        fPlateColor: '',
        fCarTypeName: '',
        fInTime: '',
        fInChnlName: '',
        fInStatus: '',
        fOutTime: '',
        fOutChnlName: '',
        fOutStatus: '',
        fTotalSecs: '',
        fFreeSecs: '',
        fPaySecs: '',
        fRateGroupName: '',
        fCalcAmt: '',
        fPayAmt: '',
        fExgDate: '',
        fExgUserName: '',
        fInPlate: '',
        fOutPlate: '',
        fInRemark: '',
        fOutRemark: '',
        CustName: '',
        fCardGroupName: '',
        fCardTypeName: '',
        fInPic: '',
        fOutPic: '',
        fInPlatePic: '',
        fOutPlatePic: '',
        fInExpiredTip: '',
        fOutExpiredTip: ''
      },
      form_dev: {
        fInCamIP: '',
        fInCamType: '',
        fInGateIP: '',
        fInGateType: '',
        fInVehDir: '',
        fInCarColor: '',
        fInSpeed: '',
        fInVehType: '',
        fInAlarm: '',
        fOutCamIP: '',
        fOutCamType: '',
        fOutGateIP: '',
        fOutGateType: '',
        fOutVehDir: '',
        fOutCarColor: '',
        fOutSpeed: '',
        fOutVehType: '',
        fOutAlarm: ''
      }
    }
  },
  props: {
    reportActiveName: String,
    type: Number,
    isOld: Boolean,
    isNeedCustIdSearch: Boolean
  },
  methods: {
    in_load (e) {
      this.in_display = 'block'
    },
    show_dev_in () {
      this.dialog_dev_Title = '【'
      if ((this.form.fCustName || '').length > 0) {
        this.dialog_dev_Title += this.form.fCustName
      }
      if ((this.form.fInParkName || '').length > 0) {
        if (this.dialog_dev_Title !== '【') {
          this.dialog_dev_Title += '-' + this.form.fInParkName
        } else {
          this.dialog_dev_Title += this.form.fInParkName
        }
      }
      if ((this.form.fInChnlName || '').length > 0) {
        if (this.dialog_dev_Title !== '【') {
          this.dialog_dev_Title += '-' + this.form.fInChnlName
        } else {
          this.dialog_dev_Title += this.form.fInChnlName
        }
      }
      if (this.dialog_dev_Title !== '【') {
        this.dialog_dev_Title += '】' + this.form.fPlateCode
      } else {
        this.dialog_dev_Title = this.form.fPlateCode
      }
      // this.form.fPlateCode_Color = this.form.fPlateCode
      // if ((this.form.fPlateColor || '').length > 0) {
      //   this.form.fPlateCode_Color += '（' + this.form.fPlateColor + '）'
      // }
      this.is_out = false
      this.dialogdevFormVisible = true
      // setTimeout(() => {
      //   this.$parent.setImgHeight() // 调用父组件的方法
      // }, 500)
      this.form_dev = {}
      api.carDevInfo({ fCustID: this.form.fCustID, fBusID: this.form.fBusID, isOld: this.isOld, fOpLastTime: this.form.fOpLastTime, type: this.type }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.form_dev = data.Data || {}
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    out_load (e) {
      this.out_display = 'block'
    },
    show_dev_out () {
      this.dialog_dev_Title = '【'
      if ((this.form.fCustName || '').length > 0) {
        this.dialog_dev_Title += this.form.fCustName
      }
      if ((this.form.fOutParkName || '').length > 0) {
        if (this.dialog_dev_Title !== '【') {
          this.dialog_dev_Title += '-' + this.form.fOutParkName
        } else {
          this.dialog_dev_Title += this.form.fOutParkName
        }
      }
      if ((this.form.fOutChnlName || '').length > 0) {
        if (this.dialog_dev_Title !== '【') {
          this.dialog_dev_Title += '-' + this.form.fOutChnlName
        } else {
          this.dialog_dev_Title += this.form.fOutChnlName
        }
      }
      if (this.dialog_dev_Title !== '【') {
        this.dialog_dev_Title += '】' + this.form.fPlateCode
      } else {
        this.dialog_dev_Title = this.form.fPlateCode
      }
      // this.form.fPlateCode_Color = this.form.fPlateCode
      // if ((this.form.fPlateColor || '').length > 0) {
      //   this.form.fPlateCode_Color += '（' + this.form.fPlateColor + '）'
      // }
      this.is_out = true
      this.dialogdevFormVisible = true
      // setTimeout(() => {
      //   this.$parent.setImgHeight() // 调用父组件的方法
      // }, 500)
      this.form_dev = {}
      api.carDevInfo({ fCustID: this.form.fCustID, fBusID: this.form.fBusID, isOld: this.isOld, fOpLastTime: this.form.fOpLastTime, type: this.type }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.form_dev = data.Data || {}
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    handleInfo (row) {
      this.in_display = 'none'
      this.out_display = 'none'
      this.payTitle = '支付明细'
      this.activeName = 'first'
      this.dialogTitle = '查看车辆信息'
      this.form = { fInPic: '', fOutPic: '', fInPlatePic: '', fOutPlatePic: '' }
      this.dialogFormVisible = true
      var param = {}
      if (row.fBigRowID && !this.isNeedCustIdSearch) {
        if (row.fType) {
          param = { id: row.fBigRowID, isOld: this.isOld, fOpLastTime: row.fOpLastTime, type: row.fType, isSync: (this.reportActiveName === 'synPageData') }
        } else {
          param = { id: row.fBigRowID, isOld: this.isOld, fOpLastTime: row.fOpLastTime, type: this.type, isSync: (this.reportActiveName === 'synPageData') }
        }
      } else {
        param = { id: 0, fCustID: row.fCustID, fBusID: row.fBusID, isOld: this.isOld, fOpLastTime: row.fOpLastTime, type: this.type, isSync: (this.reportActiveName === 'synPageData') }
      }
      api.carBusInfo(param).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            var rowData = data.Data || {}
            if ((rowData.fInPic || '').length <= 0) {
              rowData.fInPic = ' '
            }
            if ((rowData.fOutPic || '').length <= 0) {
              rowData.fOutPic = ' '
            }
            rowData.fInParkChnlName = rowData.fInChnlName
            if ((rowData.fInParkName || '').trim().length > 0) {
              rowData.fInParkChnlName += '(' + rowData.fInParkName + ')'
            }
            rowData.fOutParkChnlName = rowData.fOutChnlName
            if ((rowData.fOutParkName || '').trim().length > 0) {
              rowData.fOutParkChnlName += '(' + rowData.fOutParkName + ')'
            }
            this.form = rowData
            if ((this.form.fCustName || '').length > 0) {
              var strTitle = this.form.fCustName
              if ((this.form.fInParkName || '').length > 0) {
                strTitle += '-' + this.form.fInParkName
              } else if ((this.form.fOutParkName || '').length > 0) {
                strTitle += '-' + this.form.fOutParkName
              }
              this.dialogTitle = '【' + strTitle + '】查看车辆信息'
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
      api.carBusPayInfo({ fCustID: row.fCustID, fBusID: row.fBusID, isOld: this.isOld, fOpLastTime: row.fOpLastTime }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.payData = data.Data || []
            if (this.payData.length > 0) {
              this.payTitle = '支付明细【' + this.payData.length + '】'
            }
          } else {
            this.$message.error('提示：加载支付明细列表失败')
          }
        }
      })
    }
  },
  created () {

  },
  mounted () {

  }
}
</script>
<style>
/* dialog弹出框样式 */
#carInfoView .el-dialog {
  min-width: 840px;
}
#carInfoView .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#carInfoView .el-dialog__title {
  color: white;
}
#carInfoView .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#carInfoView .el-dialog__body {
  padding: 3px 10px;
  font-size: 13px;
  /* font-family: "宋体"; */
}
/* 文本框样式 */
#carInfoView .el-input__inner {
  height: 32px;
  line-height: 32px;
}
#carInfoView .tabRow .el-tabs__header {
  margin: 0px;
}
#carInfoView .el-input.is-disabled .el-input__inner,
#carInfoView .el-textarea.is-disabled .el-textarea__inner {
  color: #606266;
}
#carInfoView .el-tabs__item {
  height: 32px;
  line-height: 32px;
}
#carInfoView .el-input__icon {
  line-height: 32px;
}
#carInfoView .tab_img .block {
  text-align: center;
  position: relative;
}
#carInfoView .tab_img .demonstration {
  display: block;
  text-align: center;
  margin-bottom: 5px;
  margin-top: 5px;
}
#carInfoView .tab_img .el-image {
  width: 400px;
  height: 250px;
  display: inline-block;
}
#carInfoView .tab_img .image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 30px;
}
#carInfoView .car_img .el-image__inner {
  width: 200px;
  height: 80px;
}
#carInfoView .car_img .image-slot {
  width: 200px;
  height: 80px;
  background: #f5f7fa;
  color: #909399;
  font-size: 30px;
  display: inline-block;
  line-height: 80px;
  text-align: center;
}
#carInfoView .fInRemark_item .el-form-item__content {
  height: auto;
}
#carInfoView .el-dialog {
  min-width: 840px;
}
#carInfoView .isRed .el-input__inner {
  color: red !important;
}
#carInfoView .isRedColor .el-input__inner {
  color: red !important;
}
</style>
<style scoped>
.fplate_info {
  overflow: hidden;
  width: 350px;
  margin: 5px auto;
}
.car_img .img {
  width: 100%;
  height: 358px;
}
.fplate_span {
  font-size: 20px;
}
.img_zoom {
  display: none;
  position: absolute;
  right: calc((100% - 400px) / 2);
  cursor: pointer;
  background: #d1192b;
  z-index: 100;
  /* opacity: 0.5;
  filter: alpha(opacity=50); */
}
.el-form-item {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/carInfoView.vue